import { IkasPaymentGatewayAdditionalPrice } from "./additional-price";
import { IkasBaseModel } from "../base";
import { IkasPaymentGatewayTranslation } from "./translation";
import { IkasPaymentGatewaySettings } from "./settings";

export type IkasPaymentGateway = {
  additionalPrices: IkasPaymentGatewayAdditionalPrice[] | null;
  availableCountries: string[] | null;
  code: string;
  description: string | null;
  logoUrl: string | null;
  masterPassClientId: string | null;
  name: string;
  paymentGatewayProviderId: string | null;
  supportedCurrencies: string[] | null;
  testMode: boolean | null;
  type: IkasPaymentGatewayType;
  paymentMethods: IkasPaymentMethod[];
  paymentMethodType: IkasPaymentMethodType;
  settings?: IkasPaymentGatewaySettings[] | null;

  translations?: IkasPaymentGatewayTranslation[] | null;
} & IkasBaseModel;

export enum IkasPaymentMethodType {
  APP_PAYMENT = "APP_PAYMENT",
  BUY_ONLINE_PAY_AT_STORE = "BUY_ONLINE_PAY_AT_STORE",
  CASH = "CASH",
  CASH_ON_DELIVERY = "CASH_ON_DELIVERY",
  CREDIT_CARD = "CREDIT_CARD",
  CREDIT_CARD_ON_DELIVERY = "CREDIT_CARD_ON_DELIVERY",
  GIFT_CARD = "GIFT_CARD",
  MONEY_ORDER = "MONEY_ORDER",
  OTHER = "OTHER",
  WALLET = "WALLET",
}

export type IkasPaymentMethod = {
  name: string;
  logoUrl: string | null;
};

export enum IkasPaymentGatewayType {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  THIRD_PARTY = "THIRD_PARTY",
}
